export default __webpack_public_path__ + "static/media/cap.ccc31f8a.svg";